import axios from 'services/api/axios';
import { Geolocation, GeolocationRequestData } from '../types/geolocations';
import { ListItem } from '../types/lists';
import { Pagination } from '../types/pagination';

export default {
  get: async (id: number, queryString?: string): Promise<Pagination<Geolocation>> => {
    const response = await axios.get(`/lists/${id}/locations?${queryString}`);

    return response.data;
  },
  create: async (id: number, data: GeolocationRequestData): Promise<ListItem['id']> => {
    const response = await axios.post(`/lists/${id}/locations`, data);

    return response.data;
  },
  // createFromCSV: async (id: ListItem['id'], data: BundleCSVRequestData): Promise<BundleResponseData> => {
  //   const response = await axios.post(`/lists/${id}/locations-upload`, data);

  //   return response.data;
  // },
  delete: async (id: number, queryString?: string): Promise<void> => {
    const response = await axios.delete(`/lists/${id}/locations?${queryString}`);

    return response.data;
  },
};
